export default __webpack_public_path__ + "static/media/bin_green.b4ad73ec.svg";